import * as nls from 'vscode-nls/lib/main';

export const localize = nls.loadMessageBundle();
